import React, { FC } from 'react'
import { Box, makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { AuctionShipment } from 'apps/fleet-planner/types'
import { Card } from 'transfix-ui'
import { InsightsTags } from './InsightsTags'
import { MarketplaceDetails } from './MarketplaceDetails'

const useMarketplaceCardRowStyles = makeStyles(() => ({
  card: {
    borderColor: brandColors.coolGray4,
    borderRadius: 0,
  },
  insightsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 5,
  },
}))

interface IMarketplaceCardRow {
  shipment: AuctionShipment
  onShowDetailsClick: (id: number) => void
}

export const MarketplaceCardRow: FC<IMarketplaceCardRow> = ({ onShowDetailsClick, shipment }) => {
  const { id, shipmentInfo, tags } = shipment || {}
  const { pickups } = shipmentInfo

  const shipmentClickHandler = () => onShowDetailsClick(id)
  const classes = useMarketplaceCardRowStyles()

  return (
    <Box onClick={shipmentClickHandler} data-test='marketplace-card-row'>
      <Card className={classes.card}>
        <InsightsTags isMobile withLabel variant={pickups[0].appointmentType} tags={tags} />

        <MarketplaceDetails shipment={shipment} />
      </Card>
    </Box>
  )
}
